import useEmblaCarousel from 'embla-carousel-react';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';
import { useCallback, useEffect, useState } from 'react';

interface UseLightboxParams {
  selectedIndex?: number | null;
}

export const useLightbox = ({
  selectedIndex: controlledSelectedIndex
}: UseLightboxParams) => {
  const [emblaMainRef, emblaMainApi] = useEmblaCarousel(
    {
      containScroll: false
    },
    [WheelGesturesPlugin()]
  );

  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    align: 'start'
  });

  const [selectedIndex, setSelectedIndex] = useState(
    controlledSelectedIndex ?? 0
  );

  useEffect(() => {
    if (controlledSelectedIndex || controlledSelectedIndex === 0) {
      setSelectedIndex(controlledSelectedIndex);
    }
  }, [controlledSelectedIndex]);

  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onThumbClick = useCallback(
    (index: number) => {
      if (!emblaMainApi || !emblaThumbsApi) {
        return;
      }

      emblaMainApi.scrollTo(index);
    },
    [emblaMainApi, emblaThumbsApi]
  );

  const onSelect = useCallback(() => {
    if (!emblaMainApi || !emblaThumbsApi) {
      return;
    }

    setPrevBtnDisabled(!emblaMainApi.canScrollPrev());
    setNextBtnDisabled(!emblaMainApi.canScrollNext());

    setSelectedIndex(emblaMainApi.selectedScrollSnap());

    emblaMainApi.scrollTo(emblaMainApi.selectedScrollSnap());
    emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap());
  }, [emblaMainApi, emblaThumbsApi]);

  useEffect(() => {
    if (!emblaMainApi || !emblaThumbsApi) {
      return;
    }

    onSelect();

    emblaMainApi.on('select', onSelect).on('reInit', onSelect);

    emblaMainApi.scrollTo(selectedIndex);
    emblaThumbsApi.scrollTo(selectedIndex);
  }, [emblaMainApi, emblaThumbsApi, onSelect, selectedIndex]);

  return {
    emblaMainRef,
    emblaMainApi,
    emblaThumbsRef,
    emblaThumbsApi,
    selectedIndex,
    onThumbClick,
    prevBtnDisabled,
    nextBtnDisabled
  };
};
